import { createTheme } from "@material-ui/core";
import { lightTheme } from "./light";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: lightTheme.colors.primary,
    },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
});
